/*eslint-disable*/ export const messages = { New: "Neu", "Remove {label}": [["label"], " entfernen"] };
